import { handleVersionMismatch } from 'actions/versionSync';

import {
  CHOOSE_NEW_SCRAPBOOK_FAILURE,
  CHOOSE_NEW_SCRAPBOOK_REQUESTED,
  CHOOSE_NEW_SCRAPBOOK_SUCCESS,
} from 'actiontypes/myself';
import { VersionMismatch } from 'services/BaseService';
import MyselfService from 'services/MyselfService';
import { IQuality } from 'types/qualities';

const chooseNewScrapbookRequested = () => ({
  type: CHOOSE_NEW_SCRAPBOOK_REQUESTED,
  isSuccess: false,
});

const chooseNewScrapbookSuccess = (data: IQuality) => ({
  type: CHOOSE_NEW_SCRAPBOOK_SUCCESS,
  isSuccess: true,
  payload: data,
});

const chooseNewScrapbookFailure = (error: any) => ({
  type: CHOOSE_NEW_SCRAPBOOK_FAILURE,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * Choose new Scrapbook
 -----------------------------------------------------------------------------*/

const service = new MyselfService();

export default function chooseNewScrapbook(item: IQuality) {
  return async (dispatch: Function) => {
    dispatch(chooseNewScrapbookRequested());

    try {
      const { data } = await service.chooseNewScrapbook(item);
      dispatch(chooseNewScrapbookSuccess(data));
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      dispatch(chooseNewScrapbookFailure(error));
    }
  };
}